const CheckCircleIcon = ({ color = '#228B51' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6.5" stroke={color} strokeWidth="1.3" />
    <path d="m5 8.2 2.2 2.2L11 6.6" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default CheckCircleIcon
